import React from 'react'
import { ToastContainer, toast } from "react-toastify";



const Alert = (props) => {

  return (
    <>
   
    <ToastContainer
position= {props.position}
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="dark"

toastClassName="browseToast"
/> 


    
    </>
  )
}

export default Alert
